import { EmulatorType } from '@localstack/types';

export const THIRTY_DAY_TRIAL_DURATION = 30;

export const EMULATOR_LABELS: Record<EmulatorType, string> = {
  [EmulatorType.AWS]: 'AWS',
  [EmulatorType.SNOWFLAKE]: 'Snowflake',
  [EmulatorType.AZURE]: 'Azure',
};

// derived from EMULATOR_LABELS, which the compiler keeps exhaustive over EmulatorType
export const EMULATOR_TYPES = Object.keys(EMULATOR_LABELS) as EmulatorType[];

export const EMULATOR_TRIAL_TAGLINES: Record<EmulatorType, string> = {
  [EmulatorType.AWS]: 'Develop and test AWS applications locally with 110+ emulated services.',
  [EmulatorType.SNOWFLAKE]: 'Develop and test Snowflake data pipelines locally.',
  [EmulatorType.AZURE]: 'Develop and test Azure applications locally.',
};

/**
 * An area of the console, which a product either has or has never heard of. Separate from
 * whether a plan unlocks it: a feature decides what to sell on a page, an area decides whether
 * the page is worth offering at all, as Azure never advertises cloud pods.
 */
export enum ProductArea {
  INSTANCES = 'instances',
  EPHEMERAL_INSTANCES = 'ephemeral-instances',
  CLOUD_PODS = 'cloud-pods',
  STACK_INSIGHTS = 'stack-insights',
  EXTENSIONS = 'extensions',
}

const ALL_AREAS = Object.values(ProductArea);

export const EMULATOR_AREAS: Record<EmulatorType, ProductArea[]> = {
  [EmulatorType.AWS]: ALL_AREAS,
  [EmulatorType.SNOWFLAKE]: [ProductArea.INSTANCES],
  [EmulatorType.AZURE]: [],
};
